import { useUser } from '@context/user-context';
import { useMemo } from 'react';

// types
import type { EmailSignatureV2 } from '../../../types';

interface MetadataServices {
  isSignatureLocked: boolean;
}

interface MetadataServicesProps {
  emailSignature: EmailSignatureV2;
}

/*
    This component is a context wrapper that provides all the core services for the email signature side editor,
    it should be used with the email signature Side Editor component. This component allows SideEditor component to
    be reused in different editors (currently used in EmailSignatureMainEditor and EmailSignatureOnboardingEditor)
*/

function useMetadataServices({ emailSignature }: MetadataServicesProps): MetadataServices {
  const { user } = useUser();

  const isSignatureLocked = useMemo(
    () =>
      emailSignature.isTeamEmailSignature &&
      emailSignature.orgId !== user?.bbOrgId &&
      !!emailSignature.preventEditingSignature,
    [
      emailSignature.isTeamEmailSignature,
      emailSignature.orgId,
      emailSignature.preventEditingSignature,
      user?.bbOrgId,
    ],
  );

  return {
    isSignatureLocked,
  };
}

export { useMetadataServices };
